import {
  GET_DISTRICT,
  GET_DISTRICT_SUCCESS,
  GET_DISTRICT_ERROR,
} from "./actions";
import { districtState } from "./state";

export const initialDistrictState = {
  data: null,
  pending: null,
  error: null,
};

//remember to avoid mutation within reducers
export function district(state = initialDistrictState, Actions): districtState {
  switch (Actions.type) {
    case GET_DISTRICT:
      return Object.assign({}, state, { pending: true, error: null });
    case GET_DISTRICT_SUCCESS:
      return Object.assign({}, state, {
        data: { id: Actions.payload.id, name: Actions.payload.name },
        pending: false,
      });
    case GET_DISTRICT_ERROR:
      return Object.assign({}, state, { pending: false, error: "Error" });
    default:
      return state;
  }
}
